import I18n from 'i18n'
import { takeLatest, call, put } from 'redux-saga/effects'

import { SuccessToast, ErrorToast } from 'components/ui/toast/toastsTemplates'
import { ActionWithPayload } from 'helpers/redux-actions.helper'
import { ExternalCourseModelAPI } from 'models/externalCourse.model'
import externalCoursesList, {
  ExternalCoursesListParams,
  GetListResponse,
} from 'api/administration/externalCourses/GetList'
import destroyMany from 'api/administration/externalCourses/DestroyMany'
import * as fromActions from '../../actions/externalCourses.action'

function destroyExternalCourses(
  ids: ExternalCourseModelAPI['id'][],
  allSelected: boolean,
  params?: ExternalCoursesListParams
) {
  return destroyMany(ids, allSelected, params)
}

const pattern = fromActions.DESTROY_EXTERNAL_COURSES

export type DestroyExternalCoursesAction = ActionWithPayload<
  typeof pattern,
  fromActions.DestroyExternalCoursesPayload
>

function* destroyExternalCoursesSaga(action: DestroyExternalCoursesAction) {
  try {
    const { ids, allSelected, params, callback } = action.payload
    yield call(destroyExternalCourses, ids, allSelected, params)
    SuccessToast(I18n.t('administration.toastMessages.deleteSuccess_plural'))
    const resList: GetListResponse = yield call(externalCoursesList, params)
    callback && callback(resList)
    const { data, total, perPage: resPerPage } = resList
    yield put(
      fromActions.Actions.setAdministrationListSuccess(
        data,
        total,
        resPerPage,
        params?.sort
      )
    )
  } catch (error) {
    yield put(fromActions.Actions.setLoading(false))
    ErrorToast(I18n.t('administration.toastMessages.deleteError_plural'))
    console.error(error)
  }
}

export function* externalDestroyExternalCoursesSaga() {
  yield takeLatest(pattern, destroyExternalCoursesSaga)
}
